import axios from "../config/axios";

const API_BASE = "/cashbook";

const withScope = (params = {}, { locationHubId, ownerUserId, ownerUserIds, account } = {}) => ({
  ...params,
  ...(locationHubId ? { location_hub_id: locationHubId } : {}),
  ...(ownerUserId ? { owner_user_id: ownerUserId } : {}),
  ...(ownerUserIds?.length ? { owner_user_ids: ownerUserIds.join(",") } : {}),
  ...(account ? { account } : {}),
});

export const cashbookService = {
  getBranchAgents: () => axios.get(`${API_BASE}/branch-agents`),

  getReport: (date, locationHubId, ownerUserId, account, ownerUserIds) =>
    axios.get(`${API_BASE}/report`, {
      params: withScope(date ? { date } : {}, { locationHubId, ownerUserId, ownerUserIds, account }),
    }),

  getDayBook: (fromDate, toDate, locationHubId, ownerUserId, lrNo, ownerUserIds) =>
    axios.get(`${API_BASE}/day-book`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
          ...(lrNo ? { lr_no: lrNo } : {}),
        },
        { locationHubId, ownerUserId, ownerUserIds },
      ),
    }),

  getRange: (fromDate, toDate, locationHubId, ownerUserId, account, ownerUserIds, paging) =>
    axios.get(`${API_BASE}/range`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
          ...(paging?.limit ? { limit: paging.limit, offset: paging.offset || 0 } : {}),
        },
        { locationHubId, ownerUserId, ownerUserIds, account },
      ),
    }),

  getOpeningBalance: (locationHubId, ownerUserId) =>
    axios.get(`${API_BASE}/opening-balance`, {
      params: withScope({}, { locationHubId, ownerUserId }),
    }),
  setOpeningBalance: (data) => axios.post(`${API_BASE}/opening-balance`, data),

  previewTransferToAdmin: (locationHubId, toLocationHubId) => axios.get(`${API_BASE}/transfer-to-admin/preview`, {
    params: {
      ...(locationHubId ? { location_hub_id: locationHubId } : {}),
      ...(toLocationHubId ? { to_location_hub_id: toLocationHubId } : {}),
    },
  }),

  transferToAdmin: (locationHubId, toLocationHubId) => axios.post(`${API_BASE}/transfer-to-admin`, {
    location_hub_id: locationHubId || undefined,
    to_location_hub_id: toLocationHubId || undefined,
  }),

  createEntry: (data) => axios.post(`${API_BASE}/entries`, data),
  updateEntry: (entryId, data) => axios.put(`${API_BASE}/entries/${entryId}`, data),
  deleteEntry: (entryId) => axios.delete(`${API_BASE}/entries/${entryId}`),

  exportPdf: (fromDate, toDate, locationHubId, ownerUserId, account, ownerUserIds) =>
    axios.get(`${API_BASE}/export/pdf`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        { locationHubId, ownerUserId, ownerUserIds, account },
      ),
      responseType: "blob",
    }),

  exportExcel: (fromDate, toDate, locationHubId, ownerUserId, account, ownerUserIds) =>
    axios.get(`${API_BASE}/export/excel`, {
      params: withScope(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        { locationHubId, ownerUserId, ownerUserIds, account },
      ),
      responseType: "blob",
    }),
};

export default cashbookService;
